import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const MainGrid = styled.main`
	overflow: hidden;
	display: flex;
	align-items: center;
	flex-direction: column;

	${minWidth('desktop')} {
		min-height: 100vh;
	}
`;

export const Container = styled.div`
	text-align: left;
	max-width: 800px;
	min-width: 290px;
	border-radius: 50px;
	padding: 20px;
	color: ${palette('black')};
	& > * {
		padding: 10px;
	}
`;

export const Link = styled.a`
	text-decoration: underline;
	${fontWeight(FontWeights.Demi)};
	margin: 0;
	padding: 0;
	display: inline-block;
`;

export const OptoutButtonWrapper = styled.div`
	padding: 50px;
`;

export const FormWrapper = styled.form`
	grid-template-columns: 1fr;
	grid-row-gap: 1rem;
	padding: 50px;
`;

export const SuccessTextWrapper = styled.div<{
	isVisible: boolean;
}>`
	padding: 16px;
	opacity: ${p => (p.isVisible ? '1' : '0')};
`;

export const HelperLink = styled.a`
	color: ${palette('blue3')};
	text-decoration: underline;
`;
